/**
*功能名称：必填
*创 建 人：弋强
*日    期：2022/06/01 17:33:46
*/
import { ApproveData, BaseApprove } from "@newview/base-web";
import { Component, Prop, Watch } from "vue-property-decorator";
import { grid, comForm, customModal } from "@newview/ui";
import { ModuleDynamicPageApi, ModuleScriptApi, ModuleScriptTypeApi } from "@newview/dbcenter-api";

@Component({
    components: {

    }
})
export default class DynamicPage extends BaseApprove {
    async init(approveData: ApproveData, actReFlow: any) {
        this.approveData = approveData;
        this.actReFlow = actReFlow;
        this.currentData = Object.assign(this.currentData, { approveData: this.fromJS(approveData), actReFlow: this.fromJS(actReFlow) });
        await this.loadData(actReFlow.Id);
    }
    openModal(): void {
        this.ref('nimsRef').openModal();
    }
    closeModal(): void {
        this.ref('nimsRef').closeModal();
    }
    pass(isEnd: boolean, approveData: ApproveData) {
        this.ref('nimsRef').pass(isEnd, approveData);
    }
    return(isStart: boolean, approveData: ApproveData) {
        this.ref('nimsRef').return(isStart, approveData);
    }

    //#region 接口定义区

    private readonly moduleDynamicPageApi: ModuleDynamicPageApi = new ModuleDynamicPageApi();
    private readonly moduleScriptApi: ModuleScriptApi = new ModuleScriptApi();
    private readonly moduleScriptTypeApi: ModuleScriptTypeApi = new ModuleScriptTypeApi();

    //#endregion 接口定义区

    //#region 变量定义区

    currentProjectId: number = 0;
    currentChildsysId: number = 0;
    currentDevProd: string = '';

    moduleId: number = 0;
    moduleDynamicPage: any = { Id: 0 };
    currentData: any = { globalData: this.fromJS(this.$globalData_Plms) }

    previewPageSchema: any = {};
    previewPageStyle: any = "";
    pageMethodObj: any = {};

    spinShow: boolean = false;
    hasData: boolean = true;

    // 流程数据
    approveData?: ApproveData;
    actReFlow: any;

    //#endregion 变量定义区

    //#region 事件定义区

    created() {
        // const globalData: any = JSON.parse(sessionStorage.getItem('globalData_Plms')!);
        // this.currentProjectId = globalData.itemInfo.id;
        // this.currentChildsysId = globalData.subSysteminfor.id;
        // this.currentDevProd = (window as any)["devProd"];
    }

    mounted() {

    }

    //#endregion 事件定义区

    //#region 方法定义区

    async loadData(moduleId) {
        this.spinShow = true;
        this.moduleId = moduleId;
        let apiResult = await this.moduleDynamicPageApi.getEntityByFilter(this.getQueryWrapper().eq("ModuleId", this.moduleId).eq("Language", 2).eq("PageType", 2));
        const data = this.parseApiResult(apiResult);
        this.spinShow = false;
        if (this.isNull(data)) {
            this.hasData = false;
            this.previewPageSchema = { type: 'div', style: { width: '100%', height: '100%' } };
            this.previewPageStyle = "";
            this.pageMethodObj = {};
            this.moduleDynamicPage = { Id: 0, ModuleId: this.moduleId };
            return;
        }

        this.hasData = true;
        this.moduleDynamicPage = data;
        this.currentProjectId = data.ProjectId;
        this.currentChildsysId = data.ChildSysId;
        this.currentDevProd = data.DevProd;
        this.previewPageSchema = JSON.parse(this.moduleDynamicPage.PageSchema.replaceAll("`", "'"));
        this.previewPageStyle = this.moduleDynamicPage.PageStyle.replaceAll("`", "'");
        this.loadMethodObject();
    }

    /**
     * 获取方法对象
     */
    async loadMethodObject() {
        // 1. 加载基础数据
        let apiResult = await this.moduleScriptApi.getEntities(this.getQueryWrapper().eq("DynamicPageId", this.moduleDynamicPage.Id));
        let datas: any[] = this.parseApiResult(apiResult);

        apiResult = await this.moduleScriptTypeApi.getEntities(this.getQueryWrapper().eq("IsEnable", 1));
        let scriptTypes: any[] = this.parseApiResult(apiResult);

        // 2. 构造方法对象
        const methodObj: any = {};

        // 3. 生成方法元数据
        let metadata: any = {};
        for (const item of scriptTypes) {
            metadata[item.ScriptTypeCode] = Object.assign({ methods: [] }, item);
        }
        methodObj.metadata = metadata;

        // 4. 生成方法体
        for (const item of datas) {
            methodObj.metadata[item.ScriptType].methods.push(item);
            let func = new Function("$prop",
                this.isNull(item.ScriptContent) ?
                    "var i = 1" :
                    item.ScriptContent.replaceAll("`", "'").replaceAll("||\"", "\\\"").replaceAll("||n", "\\n"));
            methodObj[item.ScriptName] = func.bind(methodObj);
        }
        this.pageMethodObj = methodObj;

        this.$nextTick(() => {
            this.ref('nimsRef').init(this.approveData, this.actReFlow);
        })
    }

    //#endregion 方法定义区
}